import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex px-4 py-1.5 bg-red-50 text-red-700 items-baseline justify-center gap-1 border border-red-200 rounded-sm"
}
const _hoisted_2 = { class: "text-sm mt-0.5" }
const _hoisted_3 = {
  key: 1,
  class: "flex px-4 py-1.5 bg-red-50 text-red-700 items-baseline justify-center gap-1 border border-red-200 rounded-sm"
}
const _hoisted_4 = { class: "text-sm mt-0.5" }

import { useRouter } from 'vue-router'

import { useStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrialBanner',
  props: {
    end: {},
    status: {},
    isCanceledByUser: { type: Boolean }
  },
  setup(__props: any) {

const { end, status, isCanceledByUser } = __props;

const store = useStore();



const router = useRouter()

function formatDate(d: Date | null) {
  if (!d) return '—'
  return d.toLocaleDateString()
}

async function goToPlans() {
  if (status === "GRACE_PERIOD") {
      if (isCanceledByUser) {
        router.replace({ name: 'BillingPlans' })
      } else {
        await store.dispatch("subscription/createBillingPortalSession");
      }
  } else {
    router.replace({ name: 'BillingPlans' })
  }

}

return (_ctx: any,_cache: any) => {
  return (_ctx.status === 'GRACE_PERIOD')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('general.graceActive', { date: formatDate(_ctx.end) })), 1),
        _createElementVNode("a", { onClick: goToPlans }, _toDisplayString(_ctx.$t('general.chooseplan')), 1)
      ]))
    : (_ctx.status === 'TRIAL_ACTIVE')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('general.subscriptionEnd', { date: formatDate(_ctx.end) })), 1),
          _createElementVNode("a", { onClick: goToPlans }, _toDisplayString(_ctx.$t('general.chooseplan')), 1)
        ]))
      : _createCommentVNode("", true)
}
}

})